import React, { useState } from "react";

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Who can join?",
      answer:
        "Got zero coding skills? No worries. Got some coding skills? Even better. Whether you wanna kickstart your coding career, flex your skills for an internship, or just impress your friends by saying, “I speak Python”—CoderMonk is for you. 🚀😎",
    },
    {
      question: "What will I learn?",
      answer: "",
    },
    {
      question: "Is there a certificate?",
      answer: (
        <>
          Oh, absolutely! You'll earn an{" "}
          <span className="ans">internship certificate </span>from{" "}
          <span className="ans">DigitalMonk (yep, the real deal)</span>. But,
          just a heads-up: we like to keep things fair, so we ask for at least{" "}
          <span className="ans">70% </span>attendance. No one likes a ghost in
          the class, right? 👻
        </>
      ),
    },

    {
      question: "What are the class timings?",
      answer:
        "We don’t do “one-size-fits-all” here. Our class timings depend on the group—so if you've got a crew of like-minded peeps, we’ll work out the best time that works for you all. 🎉💻",
    },
    {
      question: "Job support?",
      answer:
        "Oh, we’ve got your back! 💼 We’ve teamed up with awesome companies to help you get that dream job. If you’re good, we’ll recommend you, and sometimes, we even hire directly from our pool of talent.",
    },
    {
      question: "What if I miss a class?",
      answer:
        "No worries! Life happens, and we’ve got your back. If you miss a class, don’t sweat it. We’ve set up Working Saturdays every other week—so you can come in and clear your doubts or catch up!",
    },
    {
      question: "Do I need to bring my laptop?",
      answer:
       <>
       Absolutely! Your laptop is your weapon of choice in the coding world. While we have systems here, having your own setup means you can practice anytime, anywhere—like a true coding pro. Plus, setting up your own development environment is part of the real-world experience.
       </>
    },
    {
      question: "How is this different from an online course?",
      answer:
       <>
     We don’t just give you videos and call it a day. This is hands-on, mentor-led training where you can ask questions, get stuck, and actually get help.
       </>
    },
    {
      question: "Can I continue learning after the course?",
      answer:
       <>
   Yes! Many of our students keep working on projects and stay in touch with our team even after completing the course.
       </>
    },
  ];

  return (
    <>

<div className="faq-container mb-5">
     
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-header"
              onClick={() => toggleFAQ(index)}
             
            >
              <h2 className="faq-question  fheading">{faq.question}</h2>
              <span className="faq-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </div>
            {openIndex === index && (
              <p className="faq-answer fheading">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
    </>
    

  
  );
};

export default FAQs;
